export function isBrowserEnvironment(): boolean {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    typeof navigator === 'undefined'
  ) {
    return false;
  }
  return !/jsdom/i.test(navigator.userAgent);
}
